<template>
  <Section id="Article3" width="95%" :title="$t('news-section.boards.b-4.title')">
    <div>
      <img :src="img" :alt="$t('news-section.boards.b-4.alt')">
      <p v-html="$t('news-section.boards.b-4.p-1')"></p>
    </div>
  </Section>
</template>

<script>
  import components from '@/components/global'
  const { Section } = components
  export default {
    components: {
      Section,
    },
    data() {
      return {
        img: './img/news/visita-deputado.jpg'
      }
    },
  }
</script>

<style lang="css" scoped>
  #Article3 div {
    float: right;
  }

  #Article3 img {
    width: 65%;
    float: left;
    margin: 20px 20px 5px 0px;
  }

  @media screen and (max-width: 900px) {
    #Article3 img {
      width: 100%;
      float: none;
      margin: 0;
    }
  }
</style>